import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Verified = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.974 21.808a.93.93 0 0 0 0 1.224l4.788 5.306c.473.522.205 1.364-.485 1.505l-6.985 1.479a.898.898 0 0 0-.715.982l.741 7.091a.913.913 0 0 1-1.277.931l-6.512-2.908a.902.902 0 0 0-1.162.37l-3.575 6.173c-.358.612-1.239.612-1.584 0l-3.575-6.173a.919.919 0 0 0-1.162-.37l-6.512 2.908a.913.913 0 0 1-1.277-.931l.74-7.091a.906.906 0 0 0-.715-.982l-6.984-1.48a.912.912 0 0 1-.485-1.504l4.788-5.306a.93.93 0 0 0 0-1.224L.238 16.502c-.473-.523-.205-1.364.485-1.505l6.984-1.48a.898.898 0 0 0 .716-.981l-.741-7.091a.913.913 0 0 1 1.277-.931l6.512 2.908a.902.902 0 0 0 1.162-.37L20.208.879c.358-.612 1.239-.612 1.584 0l3.575 6.173c.23.395.74.561 1.162.37l6.512-2.908a.913.913 0 0 1 1.277.93l-.74 7.092c-.052.459.255.88.714.982l6.985 1.48c.69.152.958.981.485 1.504l-4.788 5.306Zm-8.292-3.498a1.121 1.121 0 0 0 0-1.566 1.073 1.073 0 0 0-1.538 0l-8.839 9.002-3.448-3.521a1.073 1.073 0 0 0-1.538-.002 1.121 1.121 0 0 0-.002 1.565l4.218 4.307a1.077 1.077 0 0 0 1.538 0l9.609-9.785Z"
  }));
});
Verified.displayName = 'Verified';
Verified.defaultProps = {
  'aria-label': 'Verified'
};
export default Verified;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Verified.js
// module id = 3313
// module chunks = 11